import React, { createContext, useState, useContext } from "react";

// Create Context
const TransformedDataContext = createContext();

// Context Provider Component
export const TransformedDataProvider = ({ children }) => {
  const [transformedData, setTransformedData] = useState([]);

  return (
    <TransformedDataContext.Provider
      value={{ transformedData, setTransformedData }}
    >
      {children}
    </TransformedDataContext.Provider>
  );
};

// Custom Hook for Convenience
export const useTransformedData = () => {
  return useContext(TransformedDataContext);
};
